import { Card } from "antd";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import CardDescriptions, { CardDescriptionsItem } from "../../../../../components/Descriptions/CardDescription";


class PixData extends Component {

    constructor(props) {
        super(props);

        this.state = { expandPanel: true };
    }


    renderHeader(payment, t) {
        return (
            <a href="#" onClick={e => {
                e.preventDefault();
                this.setState({ expandPanel: !this.state.expandPanel });
            }}>
                {t('pay_with_' + payment.active)}
            </a>
        )
    }

    renderItem(title, value) {
        return <CardDescriptionsItem label={title}>{value}</CardDescriptionsItem>
    }

    render() {

        const { t, payment } = this.props;
        const { form } = payment;

        if (!form) {
            return <div>{t('not_provided')}</div>
        }

        return (

            <Card title={this.renderHeader(payment, t)}>
                <CardDescriptions column={2} >                    
                    <CardDescriptionsItem label={t('fiscal_code')}>{form.fiscal_code}</CardDescriptionsItem>
                </CardDescriptions>
            </Card>

        )
    }
}

export default withTranslation(['common'])(PixData)
